import React from 'react'
import { useSelector } from 'react-redux';

const GetStaticValue = (e) => { 
    const staticData = useSelector(state => state.staticData);
    return staticData.find(obj => obj.key === e)?.value;  
}

export default GetStaticValue